'use client';

import { useEffect, useState } from 'react';

import { css } from 'styled-system/css';

import { PRELOADED_IMAGES, PRELOADED_IMAGES_DELAY } from '@/utils/constants';

// Chakra `md` breakpoint (Show above="md" = min-width: 57em).
const ABOVE_MD_QUERY = '(min-width: 57em)';

// Chakra VisuallyHidden (visuallyHiddenStyle).
const visuallyHiddenClass = css({
  border: '0',
  clip: 'rect(0, 0, 0, 0)',
  height: '1px',
  width: '1px',
  margin: '-1px',
  padding: '0',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  position: 'absolute',
});

/**
 * layouts/PreloadedImages without Chakra: after PRELOADED_IMAGES_DELAY, warm the cache with
 * PRELOADED_IMAGES in a visually hidden span — only above `md`, like `<Show above="md">`
 * (matchMedia, not CSS: a display:none <img> would still download on mobile). Live-updates on
 * resize, as Show did.
 */
export const PreloadedImages = () => {
  const [isDelayOver, setIsDelayOver] = useState(false);
  const [isAboveMd, setIsAboveMd] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsDelayOver(true), PRELOADED_IMAGES_DELAY);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isDelayOver) return undefined;
    const query = window.matchMedia(ABOVE_MD_QUERY);
    const sync = () => setIsAboveMd(query.matches);
    sync();
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, [isDelayOver]);

  if (!isDelayOver || !isAboveMd) return null;

  return (
    <span className={visuallyHiddenClass}>
      {PRELOADED_IMAGES.map((imageUrl) => (
        // eslint-disable-next-line @next/next/no-img-element
        <img key={imageUrl} src={imageUrl} alt="preloaded" height="124px" width="124px" />
      ))}
    </span>
  );
};
